import { email, ModBox, Name, required, Spacer } from '@jfs/ui-new'
import { TextInputNew } from '../../../../../components/AdminInputs'
import * as Yup from 'yup'
import { Dropdown } from '../../../../../components/Dropdown'
import { pincodeNotMandateValidation } from '../../../../../utils'
import { styles } from '../../../styles'
import { AllowNotification } from './AllowNotification'

const mobileNumberValidation = Yup.string()
  .required('Required')
  .min(10, 'Mobile number must be 10 digits')
  .max(10, 'Mobile number must be 10 digits')
  .matches(/^[0-9]*$/, 'Only 10 digit mobile number allowed')

const landlineNumberValidation = Yup.string()
  .notRequired()
  .matches(/^([0-9]|NA)*$/, 'Only numbers are allowed')

export const cityValidationNonMandatory = Yup.string()
  .trim()
  .matches(/^[A-Za-z ]*$/, 'Invalid city name')
  .notRequired()
  .strict(false)
  .nullable()

export const contactDetailsForm = (
  isEdit: boolean,
  getLovsFromKey: any,
  showAllowNotification: boolean,
  index: number,
  allowNotification: string,
  mobileError: string,
) => [
  {
    actionTitle: 'Proceed',
    key: 'contactDetailsItem',
    formItems: [
      {
        horizontalComps: [
          {
            fieldName: 'mobileNumber',
            ComponentName: TextInputNew,
            label: 'Mobile Number',
            validationSchema: mobileNumberValidation,
            editable: isEdit,
            ...styles.textinputStyle(isEdit),
            testID: 'mobileNumber',
            maxLength: 10,
            ...(mobileError?.length > 0 && { error: mobileError }),
            paddingHorizontal: isEdit ? 8 : undefined,
          },
          {
            fieldName: 'firstName',
            ComponentName: TextInputNew,
            label: 'First Name',
            validationSchema: Name,
            editable: isEdit,
            ...styles.textinputStyle(isEdit),
            testID: 'firstName',
            paddingHorizontal: isEdit ? 8 : undefined,
          },
          {
            fieldName: 'lastName',
            ComponentName: TextInputNew,
            label: 'Last Name',
            validationSchema: Name,
            editable: isEdit,
            ...styles.textinputStyle(isEdit),
            testID: 'lastName',
            paddingHorizontal: isEdit ? 8 : undefined,
          },
          //TODO: Hidden as per Harshi mail
          // {
          //   fieldName: 'dob',
          //   ComponentName: !isEdit ? TextInputNew : DatePickerReact,
          //   label: 'DOB (DD-MM-YYYY) (Optional)',
          //   editable: isEdit,
          //   ...styles.textinputStyle(isEdit),
          //   type: !isEdit ? 'body12' : 'default',
          //   testID: 'dob',
          //   paddingHorizontal: isEdit ? 8 : undefined,
          // },
          {
            fieldName: 'gender',
            ComponentName: !isEdit ? TextInputNew : Dropdown,
            label: 'Gender',
            placeholder: '',
            title: isEdit ? 'Select' : '',
            validationSchema: required,
            editable: isEdit,
            data: getLovsFromKey('Gender'),
            ...styles.textinputStyle(isEdit),
            type: !isEdit ? 'body12' : 'default',
            ...(isEdit && { dataFieldToRead: 'description' }),
            testID: 'gender',
            paddingHorizontal: isEdit ? 8 : 0,
          },
        ],
        horizontalSpacing: 8,
      },
      {
        horizontalComps: [
          {
            fieldName: 'emailId',
            ComponentName: TextInputNew,
            label: 'Email ID',
            placeholder: '',
            title: undefined,
            validationSchema: isEdit ? email : undefined,
            editable: isEdit,
            ...styles.textinputStyle(isEdit),
            testID: 'emailId',
            paddingHorizontal: isEdit ? 8 : 0,
          },
          {
            fieldName: 'phone1',
            ComponentName: TextInputNew,
            label: 'Landline Number (Optional)',
            placeholder: '',
            editable: isEdit,
            validationSchema: landlineNumberValidation,
            // data: getLovsFromKey('DailyTxnValue'),
            ...styles.textinputStyle(isEdit),
            maxLength: 8,
            testID: 'phone1',
            paddingHorizontal: isEdit ? 8 : 0,
          },
          {
            fieldName: 'addressLine1',
            ComponentName: TextInputNew,
            label: 'Address 1 (Optional)',
            // validationSchema: required,
            placeholder: '',
            editable: isEdit,
            maxLength: 40,
            ...styles.textinputStyle(isEdit),
            testID: 'addressLine1',
            paddingHorizontal: isEdit ? 8 : undefined,
            multiline: true,
            numberOfLines: !isEdit ? 4 : 1,
          },
          {
            fieldName: 'addressLine2',
            ComponentName: TextInputNew,
            label: 'Address 2 (Optional)',
            // validationSchema: required,
            placeholder: '',
            editable: isEdit,
            maxLength: 40,
            ...styles.textinputStyle(isEdit),
            testID: 'addressLine2',
            paddingHorizontal: isEdit ? 8 : undefined,
            multiline: true,
            numberOfLines: !isEdit ? 4 : 1,
          },
        ],
        horizontalSpacing: 8,
      },
      {
        horizontalComps: [
          {
            fieldName: 'city',
            ComponentName: TextInputNew,
            label: 'City (Optional)',
            placeholder: '',
            editable: isEdit,
            maxLength: 255,
            validationSchema: cityValidationNonMandatory,
            ...styles.textinputStyle(isEdit),
            testID: 'city',
            paddingHorizontal: isEdit ? 8 : undefined,
          },
          {
            fieldName: 'state',
            ComponentName: !isEdit ? TextInputNew : Dropdown,
            label: 'State/UT (Optional)',
            placeholder: '',
            title: isEdit ? 'Select' : undefined,
            editable: isEdit,
            maxLength: 255,
            data: getLovsFromKey('State'),
            ...styles.textinputStyle(isEdit),
            ...(isEdit && { dataFieldToRead: 'description' }),
            type: !isEdit ? 'body12' : 'default',
            testID: 'state',
            paddingHorizontal: isEdit ? 8 : 0,
          },
          {
            fieldName: 'pincode',
            ComponentName: TextInputNew,
            maxLength: 6,
            label: 'Pincode (Optional)',
            placeholder: '',
            editable: isEdit,
            validationSchema: pincodeNotMandateValidation,
            ...styles.textinputStyle(isEdit),
            testID: 'pincode',
            color: 'BLACK_21',
            paddingHorizontal: 8,
          },
          {
            fieldName: 'role',
            ComponentName: !isEdit ? TextInputNew : Dropdown,
            label: 'Role',
            placeholder: '',
            title: isEdit ? 'Select' : undefined,
            validationSchema: isEdit ? required : undefined,
            editable: isEdit,
            data: getLovsFromKey('Role'),
            ...styles.textinputStyle(isEdit),
            type: !isEdit ? 'body12' : 'default',
            testID: 'role',
            paddingHorizontal: isEdit ? 8 : undefined,
          },
        ],
        horizontalSpacing: 8,
      },
      {
        horizontalComps: [
          {
            fieldName: 'spacer8882',
            ComponentName: Spacer,
          },
          {
            fieldName: 'spacer9928',
            ComponentName: Spacer,
          },
          {
            fieldName: 'spacer10',
            ComponentName: Spacer,
          },
          {
            fieldName: 'spacer133',
            ComponentName: Spacer,
          },
          {
            fieldName: 'dummyHiddenViewCp',
            ComponentName: ModBox,
            show: false,
          },
        ],
        horizontalSpacing: 8,
      },
      {
        horizontalComps: [
          {
            fieldName: 'allowNotification',
            ComponentName: AllowNotification,
            showAllowNotification: showAllowNotification,
            isEditMode: isEdit,
            index: index,
            allowNotification: allowNotification,
          },
        ],
        horizontalSpacing: 8,
      },
    ],
    horizontalFlex: 1,
    onSubmit: async () => {
      return ''
    },
  },
]
